import React, { useContext } from 'react';

export interface ChecklistContextValue {
  checklistId: string;
  accountId?: string;
  queueId: string;
}

const ChecklistContext = React.createContext<ChecklistContextValue | undefined>(undefined);

export const ChecklistProvider: React.FC<React.PropsWithChildren<ChecklistContextValue>> = ({
  children,
  ...value
}) => <ChecklistContext.Provider value={value}>{children}</ChecklistContext.Provider>;

export const useChecklistContext = (): ChecklistContextValue => {
  const ctx = useContext(ChecklistContext);
  if (!ctx) throw new Error('useChecklistContext must be used within a ChecklistProvider');
  return ctx;
};
